module.exports = __webpack_public_path__ + "static/media/pp_clear_bendable_straw3.23a7c9a0.png";